module.exports = __webpack_public_path__ + "static/media/2020.1366b5ac.png";